import { render, staticRenderFns } from "./ProductRowOne.vue?vue&type=template&id=0b7cf3da&scoped=true&"
import script from "./ProductRowOne.vue?vue&type=script&lang=js&"
export * from "./ProductRowOne.vue?vue&type=script&lang=js&"
import style0 from "./ProductRowOne.vue?vue&type=style&index=0&id=0b7cf3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7cf3da",
  null
  
)

export default component.exports